
import Callout from '../parts/Callout.vue'
import CheckCardGroup from '../parts/CheckCardGroup.vue'

export default {
    components: { Callout, CheckCardGroup },
    props: { target: { type: Object, required: true } },
    computed: {
        // yearMinus2 is the tax year the MAGI questions refer to (e.g. 2024
        // when year is 2026) — same relationship pages/survey/_uid/income-surcharges.vue
        // uses via the store's yearMinus2 getter (store/index.js:1633).
        year () { return this.$store.getters.year },
        yearMinus2 () { return this.$store.getters.yearMinus2 },
        quarterOptions () {
            return [
                { value: 'QUARTERS_40', label: 'Yes, 10+ years' },
                { value: 'QUARTERS_30_39', label: "No, but I've paid for at least 7 years and 6 months (30 quarters)" },
                { value: 'QUARTERS_LT_30', label: "No, but I've paid for 7 years and 3 months or less (29 quarters or less)" },
                { value: null, label: 'Not sure' },
            ]
        },
        filingOptions () {
            return [
                { value: 'SINGLE', label: 'Single', description: 'Filed as single or head of household' },
                { value: 'MARRIED_JOINT', label: 'Married filing jointly', description: 'One return together with your spouse' },
                { value: 'MARRIED_SEPARATELY', label: 'Married filing separately', description: 'You and your spouse each filed your own' },
            ]
        },
        showPartAFree () { return this.target.tax_quarters_paid === 'QUARTERS_40' },
        showLived () { return this.target.tax_filing_status === 'MARRIED_SEPARATELY' },
        magiOptions () {
            const key = this.magiKey(this.target.tax_filing_status, this.target.lives_with_spouse)
            if (!key) { return null }
            const opts = this.$store.getters.incomeOptionsFiledAs(this.target.tax_filing_status, undefined, this.target.lives_with_spouse)
            // incomeOptionsFiledAs returns {text, min, max, value} brackets, but
            // CheckCardGroup renders opt.label — map text -> label here so the
            // cards don't render blank (bug found in browser QA).
            return opts.map(o => ({ value: o.value, label: o.text }))
        },
        showAntic () { return !!this.target.tax_filing_status },
        showLivedAfter () { return this.target.projected_tax_filing_status === 'MARRIED_SEPARATELY' },
        anticOptions () {
            const key = this.magiKey(this.target.projected_tax_filing_status, this.target.projected_lives_with_spouse)
            if (!key) { return null }
            const opts = this.$store.getters.incomeOptionsFiledAs(this.target.projected_tax_filing_status, undefined, this.target.projected_lives_with_spouse)
            return opts.map(o => ({ value: o.value, label: o.text }))
        },
    },
    methods: {
        // Gate: separate filers must answer lived-with-spouse before brackets show
        // (the store's effectiveTaxFilingStatus handles WHICH brackets; this only
        // handles WHEN to show them — DEMO magiKey L1930-1934).
        magiKey (filing, lived) {
            if (!filing) { return null }
            if (filing !== 'MARRIED_SEPARATELY') { return filing }
            return lived === null || lived === undefined ? null : filing
        },
        pickQuarters (v) { this.$set(this.target, 'tax_quarters_paid', v) },
        // Changing the filing status invalidates BOTH dependants, not just the
        // income: the bracket is a function of (filing status, lived with
        // spouse) — see magiKey/incomeOptionsFiledAs above. Leaving the spouse
        // answer behind meant a client who picked "Married filing separately"
        // found "No" already chosen for them, inherited from a filing status
        // the question never applied to, silently deciding which bracket table
        // they were shown. It has to be their answer.
        pickFiling (v) {
            if (this.target.tax_filing_status !== v) {
                this.$set(this.target, 'current_income', null)
                this.$set(this.target, 'lives_with_spouse', null)
            }
            this.$set(this.target, 'tax_filing_status', v)
        },
        pickFilingAfter (v) {
            if (this.target.projected_tax_filing_status !== v) {
                this.$set(this.target, 'projected_income', null)
                this.$set(this.target, 'projected_lives_with_spouse', null)
            }
            this.$set(this.target, 'projected_tax_filing_status', v)
        },
        pickLived (v) {
            if (this.target.lives_with_spouse !== v) { this.$set(this.target, 'current_income', null) }
            this.$set(this.target, 'lives_with_spouse', v)
        },
        pickLivedAfter (v) {
            if (this.target.projected_lives_with_spouse !== v) { this.$set(this.target, 'projected_income', null) }
            this.$set(this.target, 'projected_lives_with_spouse', v)
        },
        pickIncome (v) { this.$set(this.target, 'current_income', v) },
        pickIncomeAfter (v) { this.$set(this.target, 'projected_income', v) },
        skip () { this.$emit('skip') },
    },
}
